export default __webpack_public_path__ + "static/media/en_badge_web_generic 1.e971ba98.svg";